module.exports = __webpack_public_path__ + "static/media/pet-type.7248d65b.svg";